import React from "react";
import styled from "styled-components";
import { formatDateMessage } from "../utils/dateFormatting";

const ScheduledStreaming = ({
  dateTime,
  selectedOption,
  streamerName,
  onEditClick,
  onDeleteClick,
  isStreamer,
}) => (
  <Block>
    <ScheduleText>{formatDateMessage(dateTime, selectedOption, streamerName)}</ScheduleText>
    {isStreamer && (
      <BtnRow>
        <SmallBtn onClick={onEditClick}>Editar hora</SmallBtn>
        <SmallBtn $danger onClick={onDeleteClick}>Borrar</SmallBtn>
      </BtnRow>
    )}
  </Block>
);

const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const ScheduleText = styled.p`
  font-family: var(--v-font-body);
  font-size: 13px;
  color: var(--v-fg);
  margin: 0;
`;

const BtnRow = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const SmallBtn = styled.button`
  background: transparent;
  border: 1px solid ${({ $danger }) => ($danger ? "rgba(255,75,75,0.3)" : "rgba(255,255,255,0.12)")};
  color: ${({ $danger }) => ($danger ? "#ff4b4b" : "var(--v-fg-muted)")};
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0.4rem 0.85rem;
  border-radius: 24px;
  cursor: pointer;
  transition: background var(--v-transition);

  &:hover {
    background: rgba(255, 255, 255, 0.04);
  }
`;

export default ScheduledStreaming;
